<template>
    <div class="user-right-wrapper" :class="{filter: !isOwn}">
        <ul class="user-right-item"  :style="{ width: `calc(var(--w) * ${datas.length * 102 - 10})` }">
            <li v-for="i in datas" :key="i.id">
                <van-image width="40" height="40" :src="i.icon" />
                <div class="a g-tc g-fs14 mt12 g-m-text-ellipsis">{{ i.name }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'userRight',
    props: {
        datas: {
            type: Array,
            default: () => []
        },
        isOwn: {
            type: Boolean,
            default: true    
        }
    }
    
}
</script>

<style lang="scss" scoped>
.mt12 {
    margin-top: calc(var(--gap) * 12);
}
.user-right-wrapper {
    overflow-y: scroll;
    &::-webkit-scrollbar{
        height: 0;
        width: 0;
        color: transparent;
    }
}
.g-m-text-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.user-right-item {
    display: flex;
    padding: calc(var(--gap) * 20) 0 calc(var(--gap) * 15) 0;
    .a {
        padding: 0 calc(var(--gap) * 10);
        word-break: break-all;
    }
    > li {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(var(--w) * 92);
        height: calc(var(--w) * 116);
        margin-right: calc(var(--gap) * 10);
        border-radius: calc(var(--gap) * 8);
        box-shadow: 0px 5px 12px 0px #eef0f2;
        flex-shrink: 0;
        padding-top: calc(var(--gap) * 14);
        box-sizing: border-box;
        overflow: hidden;
    }
    > li:last-child {
        margin-right: 0;
    }
}

</style>

<style lang="scss">
.user-right-wrapper{
    &.filter {
        color: var(--g6);
    }
    &.filter img {
        filter: grayscale(1);
        opacity: 0.3;
    }
}
</style>
